import { Interest } from './../../core/models/interest.model';
import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { User } from 'src/app/core/models/user';
import { InterestsService } from 'src/app/core/services/interests.service';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-instructor-search',
  templateUrl: './instructor-search.component.html',
  styleUrls: ['./instructor-search.component.scss']
})
export class InstructorSearchComponent implements OnInit {
  interestAreas: any[];
  subInterestAreas: any[]
  instructors: User[];
  currentSearchTerm: string;
  selectedSkill: string;
  selectedWebSite: string;
  selectFormControl = new FormControl();
  isReadMore = true;

  constructor(private userService: UserService, private interestsService: InterestsService, private window: Window) {
    this.interestAreas = [];
    this.subInterestAreas = [];
    this.currentSearchTerm = '';
    this.selectedSkill = '';
  }

  async searchForInstructor(event) {
    const val = event.target.value;
    this.currentSearchTerm = val;
    console.log('Search val ', val);
    (await this.userService.searchInstructor(val, this.selectedSkill)).subscribe(data => {
      console.log('Input Search INSTRUCTORS ', data);
      this.instructors = data;
    });
  }
  skillsSelected(val) {
    this.selectedSkill = val.interest;
    this.subInterestAreas = val.focuses;
    this.userService.searchInstructor(this.currentSearchTerm, val).subscribe(data => {
      console.log('INSTRUCTORS ', data);
      this.instructors = data;
    });

  }
  subSkillsSelected(subInterest: string) {
    this.userService.searchInstructorWithSubInterest(this.currentSearchTerm, this.selectedSkill, subInterest).subscribe(data => {
      console.log('INSTRUCTORS ', data);
      this.instructors = data;
    });
  }
  webLinkSelected(url): void {
    this.window.open(url);
  }
  showText() {
    this.isReadMore = !this.isReadMore
  }
  ngOnInit() {
    this.interestsService.getInterests().subscribe(data => {
      this.interestAreas = data;
    })

  }

}
